$mol_icon_poll $mol_icon path \M3,22V8H7V22H3M10,22V2H14V22H10M17,22V14H21V22H17Z
